// Development only: with VUE_NODE_ENV=development and VUE_APP_LOCAL_BACKEND=true the app talks to
// locally running services (Foreplay server, Lens server, Firebase Auth + Firestore emulators)
// instead of the hosted backends. All calls go to the page's own origin and the dev server proxies
// them on (see `localBackendProxy` in vue.config.js).
// Vue CLI only exposes NODE_ENV and VUE_APP_* to the browser bundle (VUE_NODE_ENV is undefined
// there), so this checks NODE_ENV, which is 'development' only under `vue-cli-service serve`.
export const useLocalBackend =
  process.env.NODE_ENV === 'development' && process.env.VUE_APP_LOCAL_BACKEND === 'true'

const origin = typeof window !== 'undefined' ? window.location.origin : ''

export const localBackend = {
  origin,
  serverUrl: `${origin}/__local/server`,
  lensUrl: `${origin}/__local/lens`,
  socketPath: '/__local/server/socket.io'
}
